"use client";
import {
  useCompositeStoreProps
} from "./IQYAUKXT.js";
import {
  useStore
} from "./Q5W46E73.js";

// src/toolbar/toolbar-store.ts
import * as Core from "@ariakit/core/toolbar/toolbar-store";
function useToolbarStoreProps(store, update, props) {
  return useCompositeStoreProps(store, update, props);
}
function useToolbarStore(props = {}) {
  const [store, update] = useStore(Core.createToolbarStore, props);
  return useToolbarStoreProps(store, update, props);
}

export {
  useToolbarStoreProps,
  useToolbarStore
};
